export default "__VITE_ASSET__DR9_zVP6__"